import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_URL_STEEL_OPERATIONAL } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import {
  GetLiDARDataVisualizationSummariesForLastSpecificHeats,
  LidarDataSummaryForVisualization,
} from "../types/getLiDARDataVisualizationSummariesForLastSpecificHeats";

const steelOperationalGraph = BaseGraphQL({
  baseUrl: GRAPHQL_URL_STEEL_OPERATIONAL,
});

export const getLiDARDataVisualizationSummariesForLastSpecificHeats = async (
  input: GetLiDARDataVisualizationSummariesForLastSpecificHeats,
) => {
  const query = `
    query($input: LiDARDataVisualizationSummariesForLastSpecificHeatInputType ) {
        getLiDARDataVisualizationSummariesForLastSpecificHeats(
            liDARDataVisualizationSummariesForLastSpecificHeatRequestVm: $input
        ) {
            messageCode
            succeed
            rowCount
            data {
                heatNumber
                campaignHeatId
                heatName
                liDARDataId
                writingDateToFolder
                liDARMeasurementsCloudFileKey
                visualizationData {
                  sidewall
                  bottom
                }
            }
        }
    }
  `;

  return await steelOperationalGraph<
    LidarDataSummaryForVisualization[],
    {
      getLiDARDataVisualizationSummariesForLastSpecificHeats: JsonResponseType<
        LidarDataSummaryForVisualization[]
      >;
    }
  >(
    {
      action: "steeloperationaldatagraphql",
      query,
      variables: {
        input,
      },
    },
    (input) => input.getLiDARDataVisualizationSummariesForLastSpecificHeats,
  );
};
